export interface RoomCreateInitiatedProps {
  estimate_id: string;
}

export type RoomCreateCancelledProps = RoomCreateInitiatedProps;

export interface RoomCreatedProps {
  estimate_id: string;
  room_name: string;
}

export interface RoomArchiveInitiatedProps {
  estimate_id: string;
  room_name: string;
  has_active_line_items: boolean;
}

export interface RoomArchiveCancelledProps {
  estimate_id: string;
  room_name: string;
}

export type RoomArchivedProps = RoomArchiveInitiatedProps;

export const ROOM_EVENTS = {
  CREATE_INITIATED: "room_create_initiated",
  CREATE_CANCELLED: "room_create_cancelled",
  CREATED: "room_created",
  ARCHIVE_INITIATED: "room_archive_initiated",
  ARCHIVE_CANCELLED: "room_archive_cancelled",
  ARCHIVED: "room_archived",
} as const;

export interface RoomEventPropertiesMap {
  [ROOM_EVENTS.CREATE_INITIATED]: RoomCreateInitiatedProps;
  [ROOM_EVENTS.CREATE_CANCELLED]: RoomCreateCancelledProps;
  [ROOM_EVENTS.CREATED]: RoomCreatedProps;
  [ROOM_EVENTS.ARCHIVE_INITIATED]: RoomArchiveInitiatedProps;
  [ROOM_EVENTS.ARCHIVE_CANCELLED]: RoomArchiveCancelledProps;
  [ROOM_EVENTS.ARCHIVED]: RoomArchivedProps;
}
